"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlight = function SvgFlight(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    stroke: "#4D4D4D",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.291 8.338 5.076 9.696s-.588.458-1.697.23c-1.109-.23-2.246-.48-2.246-.48s-.244-.09-.412.129c-.168.217.108.347.108.347l1.71 1.239s.366.361.903.266c.537-.095 2.117-.415 2.117-.415s1.078-.23 2.36-1.03c1.282-.8 5.866-3.582 5.866-3.582s1.784-1.013 1.605-1.438c-.179-.424-1.207-.31-1.7-.155-.49.155-4.329 2.33-4.329 2.33L5.155 5.695s-.544-.129-.272.189c.272.317 2.937 2.97 2.937 2.97m1.043 1.509 1.143 1.14s.331.262.398-.653.135-1.6.135-1.6"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFlight);
var _default = Memo;
exports["default"] = _default;